import Helpers from '../../common/js/helpers';

export default new class Header {
  constructor() {
    this.header = '.header';
    this.headerBurger = '.header__burger';
    this.headerClose = '.js-headerClose';
    this.headerOverlay = '.header__overlay';
    this.headerContent = '.header__content';

    this.activeClass = '_active';

    this.headerAnimationSpeed = 700;
    this.headerHideAnimationSpeed = 1000;

    this.bindEvents();
  }

  bindEvents() {
    document.querySelectorAll('.header_conteiner_img').forEach(item => {
      item.addEventListener('click', function (e) {
        e.preventDefault();
        if (this.classList.contains('open')) {
          this.classList.remove('open')
          document.getElementById(this.dataset.id).classList.add('__hide')
        } else {
          this.classList.add('open')
          document.getElementById(this.dataset.id).classList.remove('__hide')
        }
      })
    })

    if (!$(this.header).length) return;

    $(document)
      // show menu
      .on('touchstart click', this.headerBurger, () => {
        const $headerContent = $(this.headerContent);

        // show overlay
        $(this.headerOverlay).fadeIn('slow', () => {
        });

        $headerContent.addClass(this.activeClass);
        Helpers.toggleScrollBodyMobile();

        // show header menu
        $headerContent.animate({
          right: '0',
        }, 700, 'easeOutCubic', () => {

        });
      })
      // hide menu
      .on('touchstart click', this.headerClose, () => {
        Helpers.toggleScrollBodyMobile();
        this.hideHeader();
      });
    // change menu position on device change rotation
    window.addEventListener('orientationchange', () => {
      if ($(this.headerContent).hasClass(this.activeClass)) {
        Helpers.toggleScrollBodyMobile();
        this.hideHeader();
        this.setHeaderStyles();
      }
    }, false);
  }

  /**
   * hide header menu
   */
  hideHeader() {
    const $headerContent = $(this.headerContent);

    // hide overlay
    $(this.headerOverlay).fadeOut('slow', () => {
    });

    $headerContent.removeClass(this.activeClass);

    $headerContent.animate({
      right: -($headerContent.width() + 500),
    }, this.headerHideAnimationSpeed, 'easeOutCubic');
  }


  /**
   * Set default styles props for header hidden menu
   */
  setHeaderStyles() {
    const $headerContent = $(this.headerContent);

    $headerContent.css('right', -($headerContent.width() + 500));
  }
}();
